import { LegalEntityEnum, MatrixType, OrderType } from '@onrunning/backstage-models';

export const orderOverviewId = 'overview_id';

export const CARRY_OVER_UNAVAILABLE_DAYS = 14;

export const CARRY_OVER_RESTRICTED_LEGAL_ENTITIES = [
  LegalEntityEnum.ON_AG,
  LegalEntityEnum.ON_UK,
  LegalEntityEnum.ON_CN,
  LegalEntityEnum.ON_AU,
  LegalEntityEnum.ON_KR,
  LegalEntityEnum.ON_HK,
  LegalEntityEnum.ON_JP,
];

export const DISALLOWED_REORDER_LEGAL_ENTITIES = [] as LegalEntityEnum[];

export const REORDER_WARNING_LEGAL_ENTITIES = [] as LegalEntityEnum[];

export const VISIBLE_STOCK_MATRIX_TYPES = [MatrixType.order, MatrixType.lastSeason] as MatrixType[];

export const PRICE_DISABLED_ORDER_TYPES = new Set<OrderType>([OrderType.LastSeason]);

export const SELECTABLE_FIELDS_DISABLED_ORDER_TYPES = new Set<OrderType>([
  OrderType.LastSeason,
  OrderType.WarrantyOrder,
  OrderType.ReturnOrder,
]);
